module.exports = __webpack_public_path__ + "static/media/meritize-loading-indicator.28b9fe61.gif";